/**
 * List of legacy (that don’t need a trailing `;`) named references which could,
 * depending on what follows them, turn into a different meaning
 *
 * @type {Array<string>}
 */
export const dangerous = ['cent', 'copy', 'divide', 'gt', 'lt', 'not', 'para', 'times'];